import { BOOKING_PANEL_AD_SLOT_ID } from '@web-platform/shared-universal-constants/src/adverts';
import {
  QUERY_REQUEST_SENT,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { ADS_RETRIEVAL_SERVICE_BOOKING_PANEL } from '@web-platform/shared-universal-types/src/network/requestTypes';

import {
  ACORN_BOOKING_PANEL_STATE_CHANGE,
  BANANA_BOOKING_PANEL_STATE_CHANGE,
} from '../../../features/redirect/actions';

import { transformARSCreativeToBookingPanelAdvert } from './transformARSCreativeToBookingPanelAdvert';

import type { BookingPanelStateChangeAction } from '../../../features/redirect/actions';
import type { AdsRetrievalServiceBookingPanelPayloadResponse } from '@web-platform/shared-universal-types/src/network/types';
import type {
  QueryRequestAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  BookingPanelOptionAdvert,
  SponsoredPricingOptionAdvertStateBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/advertsBookingPanel';

type Action = QueryRequestAction | QueryResponseAction | BookingPanelStateChangeAction;

const INITIAL_STATE: SponsoredPricingOptionAdvertStateBookingPanel = {
  advert: null,
  inflightRequestId: null,
};

export const extractBookingPanelAdverts = (
  response: AdsRetrievalServiceBookingPanelPayloadResponse,
): BookingPanelOptionAdvert | null => {
  if (
    response?.error ||
    !(BOOKING_PANEL_AD_SLOT_ID in response.body.creatives) ||
    !response.body.creatives[BOOKING_PANEL_AD_SLOT_ID]
  ) {
    return null;
  }

  return transformARSCreativeToBookingPanelAdvert(
    response.body.creatives[BOOKING_PANEL_AD_SLOT_ID],
  );
};

const bookingPanelAdvert = (
  state: SponsoredPricingOptionAdvertStateBookingPanel = INITIAL_STATE,
  action: Action,
): SponsoredPricingOptionAdvertStateBookingPanel => {
  switch (action.type) {
    case QUERY_REQUEST_SENT: {
      if (action.payload.type === ADS_RETRIEVAL_SERVICE_BOOKING_PANEL) {
        const { requestGuid } = action.payload.variables;
        return {
          ...state,
          // '' (not null) so a guid-less in-flight request is distinct from
          // INITIAL_STATE.inflightRequestId, which is also null.
          inflightRequestId: typeof requestGuid === 'string' ? requestGuid : '',
        };
      }
      return state;
    }
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type === ADS_RETRIEVAL_SERVICE_BOOKING_PANEL) {
        const { requestGuid } = action.payload.variables;
        const responseRequestId = typeof requestGuid === 'string' ? requestGuid : '';
        if (state.inflightRequestId === responseRequestId) {
          const advert = extractBookingPanelAdverts(action.payload.response);
          return advert ? { advert, inflightRequestId: null } : INITIAL_STATE;
        }
      }
      return state;
    }

    case BANANA_BOOKING_PANEL_STATE_CHANGE:
    case ACORN_BOOKING_PANEL_STATE_CHANGE: {
      if (!action.payload.isOpen) {
        return INITIAL_STATE;
      }
      return state;
    }

    default:
      return state;
  }
};

export default bookingPanelAdvert;
